import {TrainingDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_TRAINING_BY_ID';

export async function getTrainingById(userData: Record<string, string>, id: number) {
    try {

        return await TrainingDao.getTrainingById(userData.userToken, id);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
